import { render } from "./TagsView.vue?vue&type=template&id=7781373d&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"

import "./TagsView.vue?vue&type=style&index=0&id=7781373d&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import "./TagsView.vue?vue&type=style&index=1&id=7781373d&rel=stylesheet%2Fscss&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7781373d"]])

export default __exports__